import CampaignIcon from "@mui/icons-material/Campaign";
import ListCampaigns from "./List";
import CreateCampaigns from "./Create";
import EditCampaigns from "./Edit";
import ShowCampaigns from "./Show";
import { CAMPAIGNS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: SpecialistServicePath + CAMPAIGNS,
  title: "Кампании",
  list: <ListCampaigns />,
  create: <CreateCampaigns />,
  edit: <EditCampaigns />,
  show: <ShowCampaigns />,
  permission: permissions.canPreviewSpecialistCampaigns,
  showPermission: permissions.canPreviewSpecialistCampaigns,
  createPermission: permissions.canManageSpecialistCampaigns,
  editPermission: permissions.canManageSpecialistCampaigns,
};
